{
  "branding": {
    "frontdesk-attribution": "S technológiou FrontDesk+",
    "practice-logo": "Logo {{name}}"
  },
  "validation": {
    "required": "Toto pole je povinné",
    "invalid-url": "Prosím zadajte platnú URL adresu",
    "pin-too-short": "PIN musí mať aspoň 4 znaky",
    "pin-default-rejected": "Štandardný PIN 0000 nie je povolený. Priraďte svoj vlastný kód PIN.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Späť",
    "next": "Ďalej",
    "cancel": "Zrušiť",
    "confirm": "Potvrdiť",
    "done": "Hotovo",
    "retry": "Skúsiť znova",
    "clear": "Vymazať",
    "close": "Zavrieť",
    "verifying": "Overovanie...",
    "select": "Vybrať",
    "minutes": "minút",
    "clock": "",
    "gender": {
      "M": "Muž",
      "W": "Žena",
      "D": "Rôzne",
      "U": "Neznáme"
    },
    "insurance": {
      "GKV": "Zákonné",
      "PKV": "Súkromné",
      "SELFPAY": "Samoplatba"
    },
    "scroll-up": "Posunúť nahor",
    "scroll-down": "Posunúť nadol"
  },
  "settings": {
    "device-reset": {
      "title": "Obnoviť zariadenie",
      "description": "Odstrániť pripojenie k ambulancii, nastavenia a PIN tohto zariadenia.",
      "confirmation": "Zariadenie bude potrebné znova nastaviť. Konfigurácia SOL a údaje pacientov v inSuite zostanú nezmenené.",
      "cancel": "Zrušiť",
      "confirm": "Obnoviť teraz"
    },
    "title": "Nastavenia",
    "save": "Uložiť",
    "save-success": "Nastavenia uložené",
    "save-error": "Chyba pri ukladaní nastavení",
    "load-error": "Chyba pri načítaní nastavení",
    "pin": {
      "title": "Vyžadovaný PIN",
      "description": "Prosím zadajte svoj PIN pre prístup k nastaveniam.",
      "error": "Nesprávny PIN. Prosím skúste to znova.",
      "backspace": "Vymazať poslednú číslicu"
    },
    "connection": {
      "title": "Pripojenie",
      "description": "Nastavenia pripojenia k serveru Doc-Cirrus Bridge",
      "bridge-url": "URL Bridge",
      "device-name": "Názov zariadenia",
      "device-name-placeholder": "napr. Recepcia, miestnosť 1, kiosk",
      "device-name-hint": "Názov na identifikáciu v prístrojovej doske Bridge",
      "kim-address": "Adresa KIM (voliteľné)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Test",
      "success": "Pripojenie úspešné",
      "error": "Pripojenie zlyhalo",
      "api-unreachable": "API DocCirrus je nedostupné",
      "status-title": "Stav pripojenia",
      "status": {
        "api": "API pripojené",
        "ti": "Telematická infraštruktúra",
        "card-reader": "K dispozícii je čítačka kariet",
        "medical-card": "Karta ordinácie (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol token (z inSuite)",
      "sol-token-hint": "Skopírujte ho zo správy Bridge v inSuite. Je potrebný na pripojenie.",
      "sol-token-show": "Zobraziť token",
      "sol-token-hide": "Skryť token",
      "bridge-unreachable": "Bridge nie je dostupný. Skontrolujte adresu a port.",
      "diagnostic-id": "ID diagnostiky: {{id}}",
      "scan-qr": "Naskenovať QR kód",
      "scan-title": "Naskenovať QR kód Bridge",
      "scan-manual": "Zadať ručne"
    },
    "terminal": {
      "title": "Čítačka kariet",
      "description": "Výber čítačky kariet pre telematickú infraštruktúru",
      "select": "Vybrať terminál",
      "select-placeholder": "Vyberte terminál...",
      "loading": "Načítavanie terminálov...",
      "none-available": "Žiadne dostupné terminály",
      "none-found": "Nenašli sa žiadne terminály",
      "found": "Nájdených {{count}} terminál(ov)",
      "connect-hint": "Najprv sa pripojte k bridge serveru pre načítanie terminálov.",
      "found-count": "Nájdené čítačky kariet: {{count}}",
      "refresh": "Znova načítať čítačky kariet"
    },
    "practice": {
      "title": "Ordinácia",
      "description": "Informácie o vašej ordinácii",
      "name": "Názov ordinácie",
      "name-placeholder": "napr. MUDr. Novák",
      "welcome-message": "Uvítacia správa",
      "welcome-placeholder": "napr. Vitajte v našej ordinácii",
      "scheduler-available": "Povoliť plánovač",
      "scheduler-available-description": "Umožnite pacientom rezervovať si termíny cez samoobslužný terminál",
      "prescription-available": "Povoliť službu predpisovania",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Nechajte prázdne, aby sa pozdrav zobrazil v jazyku pacienta. Vlastný text sa vo všetkých jazykoch zobrazí bez zmeny."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Uložené pre všetky zariadenia {{value}}",
      "never-saved-default": "Predvolené nastavenie, zatiaľ nezmenené."
    },
    "anamnesis": {
      "title": "Digitálna anamnéza",
      "description": "Po prihlásení zobrazí odkaz a QR code vášmu poskytovateľovi anamnézy.",
      "enabled": "Po prihlásení zobraziť odkaz na anamnézu",
      "enabled-description": "Zobrazí odkaz a QR code na vášho poskytovateľa anamnézy po dokončení registrácie, napríklad Nelly.",
      "url": "Odkaz na poskytovateľa anamnézy",
      "url-hint": "Odkaz je statický a rovnaký pre všetkých pacientov.",
      "preview-label": "Ukážka obrazovky dokončenia",
      "preview-note": "Odkaz je statický a rovnaký pre všetkých pacientov.",
      "url-first": "Na zapnutie najprv zadajte platný odkaz."
    },
    "appearance": {
      "title": "Vzhľad",
      "description": "Prispôsobte používateľské rozhranie",
      "language": "Jazyk",
      "default-kiosk-language": "Predvolený jazyk pacienta",
      "default-kiosk-language-hint": "Jazyk, v ktorom sa začínajú nové relácie kiosku pre pacientov.",
      "voice-over-volume": "Hlasitosť hlasu",
      "voice-over-hint": "Ovláda hlasitosť hlasového asistenta pre dostupnosť.",
      "language-first": "Zobraziť výber jazyka na začiatku relácie"
    },
    "security": {
      "title": "Zabezpečenie",
      "description": "PIN pre prístup k nastaveniam",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Správa kiosku",
    "nav": {
      "general": "Všeobecné",
      "flows": "Funkcie",
      "anamnese": "Digitálna anamnéza",
      "device": "Zariadenie a pripojenie"
    },
    "flows": {
      "title": "Funkcie na termináli"
    },
    "language": {
      "title": "Jazyk a hlasový výstup",
      "description": "Jazyk a predčítanie pre pacientov na tomto zariadení."
    }
  },
  "self-service": {
    "title": "Samoobsluha",
    "step-progress": "Krok {{current}} / {{total}}",
    "flows": {
      "checkin": "Registrácia",
      "scheduler": "Objednať sa",
      "prescription": "Predpisy",
      "locations": "Mapa polohy",
      "emergency": "Pohotovosť"
    },
    "audio-guide": {
      "on": "Zvuk zapnutý",
      "off": "Zvuk vypnutý",
      "replay": "Zopakovať pokyny",
      "replay-unavailable": "Žiadne hlasové pokyny na zopakovanie"
    },
    "language-selector": {
      "title": "Vyberte jazyk",
      "description": "Prosím vyberte preferovaný jazyk"
    },
    "settings": "Nastavenia",
    "start": {
      "welcome": "Vitajte",
      "subtitle": "Prosím vyberte možnosť",
      "check-in-label": "Hlavná cesta",
      "check-in-cta": "Registrácia",
      "check-in-description": "Už máte objednanie? Zaregistrujte sa tu.",
      "check-in-hint": "Pripravte si kartu",
      "scheduler-label": "Nové",
      "scheduler-cta": "Objednať sa",
      "scheduler-description": "Naplánujte novú návštevu.",
      "location-plan": "Mapa polohy",
      "location-plan-description": "Nájdite cestu k ošetrovni.",
      "prescription-label": "Predpis",
      "prescription-cta": "Predpisy a objednávky",
      "prescription-description": "Zobrazenie receptov alebo doplnenia objednávok.",
      "emergency-cta": "Miestny núdzový alarm",
      "emergency-description": "Znie iba na tomto zariadení a neprivolá pomoc.",
      "tap-to-start": "Začnite klepnutím"
    },
    "offline": {
      "banner-title": "Prihlásenie dočasne nedostupné",
      "banner-message": "Požiadajte o pomoc personál recepcie.",
      "emergency-available": "Miestny alarm zostáva dostupný. Neprivolá pomoc.",
      "flow-disabled": "Dočasne nedostupné"
    },
    "readability": {
      "toggle-label": "Režim čítania",
      "on": "Režim čítania",
      "off": "Režim čítania"
    },
    "reset-overlay": {
      "timeout-title": "Relácia ukončená",
      "timeout-subtitle": "Váš čas vypršal. Vaše údaje sú v bezpečí.",
      "offline-title": "Prerušenie spojenia",
      "offline-subtitle": "Spojenie bolo prerušené. Porozprávajte sa, prosím, s personálom recepcie.",
      "interruption-title": "Relácia ukončená",
      "interruption-subtitle": "Vaša relácia bola bezpečne ukončená.",
      "completion-title": "Ďakujem!",
      "completion-subtitle": "Vaša požiadavka bola úspešne dokončená.",
      "reassurance": "Vaše osobné údaje nie sú uložené v tomto zariadení.",
      "auto-dismiss": "Návrat na začiatok o {{seconds}} sekúnd...",
      "dismiss": "Prejsť na začiatok"
    },
    "timed-terminal": {
      "countdown": "Automatický návrat za {{seconds}} sekúnd",
      "countdown-outcome": "Tento terminál sa automaticky vráti na úvodnú obrazovku.",
      "more-time": "Viac času",
      "extended": "Čas predĺžený"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Tieto otázky nie sú dostupné vo vašom jazyku. Vyberte si niektorý z ponúkaných jazykov alebo sa obráťte na recepciu.",
        "alternatives": "Alternatívne termíny",
        "loading": "Načítavajú sa otázky…",
        "reception-fallback": "Obráťte sa, prosím, na recepciu.",
        "error-title": "Otázky sa nepodarilo načítať",
        "language-unavailable-lead": "Tieto otázky nie sú vo vašom jazyku k dispozícii.",
        "language-unavailable-title": "Vyberte, prosím, jeden z týchto jazykov",
        "language-unavailable-body": "Alebo si nechajte pomôcť na recepcii."
      },
      "start": {
        "title": "Objednať sa",
        "subtitle": "Objednajte si preferovaný termín v niekoľkých krokoch",
        "welcome": "Vitajte v objednávaní termínov",
        "description": "Prevedieme vás procesom objednania",
        "cta": "Objednať sa teraz"
      },
      "patient-id": {
        "title": "Identifikácia",
        "subtitle": "Prosím identifikujte sa",
        "mode-card": "S kartou",
        "mode-search": "Vyhľadať",
        "mode-create": "Vytvoriť nový",
        "insert-card": "Prosím vložte svoju zdravotnú kartu",
        "reading-card": "Čítanie karty...",
        "simulate-card": "Simulovať kartu",
        "multiple-matches": "Nájdených viac pacientov. Používajú sa údaje z karty.",
        "search-placeholder": "Meno alebo číslo poistenia...",
        "searching": "Vyhľadávanie...",
        "no-results": "Nenašli sa žiadne výsledky",
        "first-name": "Meno",
        "last-name": "Priezvisko",
        "dob": "Dátum narodenia",
        "insurance": "Poistenie",
        "continue": "Pokračovať",
        "creating": "Vytváranie pacienta...",
        "patient-created": "Pacient bol úspešne vytvorený!",
        "create-error": "Nepodarilo sa vytvoriť pacienta."
      },
      "appointment-type": {
        "title": "Vyberte typ návštevy",
        "subtitle": "Prosím vyberte dôvod vašej návštevy",
        "loading": "Načítavanie typov návštev...",
        "no-types": "Žiadne dostupné typy návštev",
        "error": "Nie je možné načítať typy návštev. Prosím skúste to znova.",
        "no-bookable": "Tieto typy termínov momentálne nie je možné rezervovať v kiosku. Obráťte sa prosím na recepciu alebo si dohodnite termín telefonicky.",
        "disabled-default": "Tento termín si prosím dohodnite priamo na recepcii alebo telefonicky.",
        "disabled-footer": "Iba recepcia/telefón",
        "lead": "Aký druh termínu chcete rezervovať?",
        "duration": "cca {{minutes}} minút",
        "empty-title": "Termíny tu teraz nie je možné rezervovať",
        "none-bookable-title": "Tieto termíny tu nemôžete rezervovať",
        "none-bookable-body": "Opýtajte sa, prosím, na recepcii alebo nám zavolajte."
      },
      "types": {
        "general": "Všeobecná konzultácia",
        "general-desc": "Pre všeobecné ťažkosti a otázky",
        "checkup": "Preventívna prehliadka",
        "checkup-desc": "Pravidelné zdravotné prehliadky",
        "vaccination": "Očkovanie",
        "vaccination-desc": "Naplánujte očkovanie",
        "followup": "Kontrola",
        "followup-desc": "Kontrolná návšteva",
        "prescription": "Recept",
        "prescription-desc": "Vyzdvihnutie receptu"
      },
      "slot-selection": {
        "title": "Vyberte termín",
        "subtitle": "Prosím vyberte dostupný termín",
        "loading": "Načítavanie dostupných termínov...",
        "no-slots": "Žiadne dostupné termíny",
        "no-appointment-type": "Nebol vybraný typ návštevy",
        "error": "Nie je možné načítať dostupné termíny. Prosím skúste to znova.",
        "quick-select": "Ďalšie dostupné termíny:",
        "select-date": "Alebo vyberte dátum:",
        "times-for": "{{date}}",
        "available": "Dostupné",
        "unavailable": "Žiadne termíny",
        "slots": "termíny",
        "select-time-hint": "Klepnite na čas pre objednanie termínu",
        "week-short": "Týž",
        "weekday-mon": "Po",
        "weekday-tue": "Ut",
        "weekday-wed": "St",
        "weekday-thu": "Št",
        "weekday-fri": "Pi",
        "weekday-sat": "So",
        "weekday-sun": "Ne",
        "period-morning": "Ráno",
        "period-midday": "Poludnie",
        "period-afternoon": "Popoludnie",
        "period-evening": "Večer",
        "period-morning-short": "Ráno",
        "period-midday-short": "Pol.",
        "period-afternoon-short": "Pop.",
        "period-evening-short": "Večer",
        "period-dots-legend": "Dostupnosť času",
        "filter-hint": "Filtrovať podľa preferovaných časov:",
        "or-choose-below": "alebo vyberte nižšie",
        "no-slots-period": "Žiadne sloty",
        "show-all": "Zobraziť všetko",
        "free": "zadarmo",
        "your-selection": "Váš výber",
        "oclock": "hodiny",
        "choose-slot": "Vyberte slot",
        "choose-day": "Vybrať deň",
        "choose-day-first": "Najprv, prosím, vyberte deň",
        "times-heading": "Voľné časy {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Žiadne voľné termíny: {{month}}",
        "empty-body": "Pozrite sa na ďalší mesiac alebo sa opýtajte na recepcii – radi pomôžeme.",
        "next-month": "Ďalší mesiac",
        "previous-month": "Predchádzajúci mesiac"
      },
      "confirmation": {
        "patient-responses": "Vaše odpovede",
        "review-loading": "Kontrola súhrnu…",
        "review-unavailable": "Zhrnutie nie je k dispozícii. Skúste to, prosím, znova alebo sa opýtajte na recepcii.",
        "check-booking": "Skontrolovať rezerváciu",
        "title": "Potvrdiť termín",
        "subtitle": "Prosím skontrolujte svoju rezerváciu",
        "patient": "Pacient",
        "datetime": "Dátum a čas",
        "booking": "Rezervácia...",
        "confirm": "Objednať termín",
        "heading": "Vyzerá to správne?",
        "lead": "Potvrďte termín.",
        "appointment": "Menovanie",
        "insured-via": "Poistený cez",
        "description-label": "Poznámky pre ambulanciu (voliteľné)",
        "description-hint": "Dajte nám vedieť, ak máme pri objednávaní alebo registrácii niečo zohľadniť.",
        "description-placeholder": "napr. obmedzená pohyblivosť, sprievod, dôležité poznámky",
        "description-too-long": "Skráťte prosím poznámku na najviac 500 znakov.",
        "summary": "Zhrnutie",
        "change": "Zmeniť",
        "book-binding": "Objednajte si termín",
        "cancel": "Zrušiť",
        "type-label": "Druh termínu",
        "datetime-value": "{{date}} o {{time}}",
        "name-label": "Meno",
        "insurance-label": "Poistenie",
        "insurance-GKV": "Verejné zdravotné poistenie",
        "insurance-PKV": "Súkromné zdravotné poistenie",
        "insurance-SELFPAY": "Samoplatca",
        "change-time": "Zmeniť termín",
        "description-free-text": "Ďalšie poznámky (nepovinné)",
        "note-wheelchair": "Používam invalidný vozík",
        "note-companion": "Prídem so sprievodom",
        "note-interpreter": "Potrebujem tlmočníka"
      },
      "done": {
        "title": "Termín objednaný!",
        "label": "Zarezervované",
        "subtitle": "Váš termín bol úspešne objednaný.",
        "date": "Dátum",
        "time": "Čas",
        "booking-id": "Číslo rezervácie",
        "qr-hint": "Pridať do kalendára",
        "qr-description": "Naskenujte tento QR kód kamerou svojho smartfónu pre pridanie termínu do aplikácie kalendára",
        "auto-redirect": "Čoskoro budete presmerovaní na úvodnú stránku...",
        "auto-redirect-countdown": "Návrat na začiatok za {{seconds}} sekúnd...",
        "back-to-start": "Späť na začiatok",
        "print-button": "Vytlačiť lístok s termínom",
        "print-preparing": "Pripravuje sa náhľad tlače…",
        "print-error": "Lístok s termínom sa nepodarilo otvoriť. Skúste to znova alebo požiadajte o pomoc na recepcii.",
        "print-returned": "Systémový náhľad tlače bol zatvorený. V prípade potreby môžete požiadať o ďalšiu kópiu.",
        "print-title": "Váš termín",
        "print-location": "Miesto",
        "print-map-hint": "Otvoriť miesto v telefóne",
        "print-error-v2": "Lístok s termínom sa nepodarilo otvoriť. Skúste to, prosím, znova alebo sa opýtajte na recepcii."
      },
      "error": {
        "assistance-info": "Vašu rezerváciu sa nepodarilo potvrdiť. Termín je možno už rezervovaný. Opýtajte sa, prosím, na recepcii.",
        "pending-title": "Rezervácia nepotvrdená",
        "pending-info": "Vašu rezerváciu sa nepodarilo potvrdiť. Termín je možno už rezervovaný. Skontrolujte to, prosím, znova alebo sa opýtajte na recepcii.",
        "title": "Objednanie zlyhalo",
        "subtitle": "Termín nemohol byť objednaný.",
        "info": "Skúste to, prosím, znova alebo sa opýtajte na recepcii."
      },
      "phase": {
        "identify": "Prihlásenie",
        "choose": "Výber termínu",
        "confirm": "Potvrdenie"
      }
    },
    "prescription": {
      "start": {
        "title": "Predpisy a objednávky",
        "subtitle": "Vložte svoju kartičku poistenca, aby ste si mohli pozrieť recepty alebo doplnenia objednávok.",
        "button": "Vložte kartu"
      },
      "card-check": {
        "loading": "Načítava sa čítačka kariet...",
        "no-terminal": "Nie je nakonfigurovaná žiadna čítačka kariet",
        "no-terminal-hint": "Požiadajte o pomoc personál.",
        "insert-card": "Vložte svoju kartu",
        "insert-card-hint": "Vložte kartu poistenca do čítačky kariet.",
        "card-detected": "Rozpoznaná karta",
        "reading": "Čítanie karty...",
        "reading-hint": "Chvíľu počkajte.",
        "error": "Chyba pri čítaní karty",
        "retry": "Skúste to znova",
        "manual-lookup": "Pokračovať bez karty",
        "load-error": "Nepodarilo sa načítať čítačku kariet",
        "read-error": "Kartu nebolo možné prečítať"
      },
      "patient-selection": {
        "title": "Vyberte položku Pacient",
        "subtitle": "Našlo sa viacero pacientov. Vyberte svoje meno.",
        "try-again": "Skúste to znova",
        "try-again-hint": "Znova vložte kartu"
      },
      "list": {
        "title": "Vaše predpisy",
        "for-patient": "Predpisy pre {{name}}",
        "loading": "Načítavam recepty...",
        "error-title": "Chyba pri načítavaní",
        "fetch-error": "Predpisy sa nepodarilo načítať",
        "back-home": "Späť na začiatok",
        "done": "Hotovo"
      },
      "detail": {
        "prescription-info": "Informácie o predpisoch",
        "date": "Dátum",
        "prescriber": "Predpisujúci lekár",
        "comment": "Pozn",
        "medications": "Lieky",
        "form": "Formulár",
        "pack-size": "Veľkosť balenia",
        "manufacturer": "Výrobca",
        "loading": "Načítavam predpis...",
        "fetch-error": "Podrobnosti predpisu sa nepodarilo načítať",
        "back-to-list": "Späť na zoznam",
        "print": "Tlač"
      },
      "types": {
        "public": "Verejný predpis",
        "private": "Súkromný predpis",
        "long-term": "Dlhodobé premlčanie",
        "btm": "Narkotický predpis",
        "g": "Zelený recept",
        "t": "T-Preskripcia"
      },
      "no-patient": {
        "title": "Pacient sa nenašiel",
        "subtitle": "Žiaľ, pre túto kartu sa nenašiel žiadny pacient. Požiadajte o pomoc personál.",
        "try-again": "Skúste znova",
        "back-home": "Späť na začiatok",
        "title-v2": "Nenašli sa žiadne zodpovedajúce údaje",
        "subtitle-v2": "Nepodarilo sa vás nájsť. Skúste to, prosím, znova alebo sa opýtajte na recepcii."
      },
      "done": {
        "title": "Ďakujem",
        "subtitle": "Teraz si môžete sadnúť. Ak máte otázky, kontaktujte personál.",
        "no-prescriptions-title": "Žiadne predpisy v spise",
        "no-prescriptions-subtitle": "Nenašli sme pre vás žiadne aktívne recepty. Ak ho očakávate, kontaktujte personál recepcie.",
        "error-title": "Vyskytla sa chyba",
        "error-subtitle": "Ak potrebujete ďalšiu pomoc, kontaktujte personál.",
        "auto-redirect": "Automatické presmerovanie za {{seconds}} sekúnd",
        "finish": "Back to Start"
      },
      "hub": {
        "title": "Your Prescriptions",
        "for-patient": "Prescriptions for {{name}}",
        "loading": "Loading prescriptions...",
        "error-title": "Loading Error",
        "fetch-error": "Could not load prescriptions",
        "back-home": "Back to Start",
        "done": "Hotovo",
        "order-button": "Predpis objednávky",
        "existing-prescriptions": "Vaše aktuálne predpisy",
        "no-prescriptions": "Nenašli sa žiadne aktívne recepty."
      },
      "patient-lookup": {
        "title": "Nájsť pacienta",
        "subtitle": "Zadajte svoje meno a dátum narodenia.",
        "last-name": "Priezvisko",
        "first-name": "Krstné meno",
        "date-of-birth": "Dátum narodenia",
        "lastname": "Priezvisko",
        "lastname-placeholder": "Vaše priezvisko",
        "firstname": "Krstné meno",
        "firstname-placeholder": "Vaše krstné meno",
        "dob": "Dátum narodenia",
        "search": "Hľadať",
        "searching": "Vyhľadávanie...",
        "search-error": "Chyba vyhľadávania: {{message}}",
        "no-match": "Nenašiel sa žiadny pacient. Skontrolujte svoje údaje.",
        "error": "Chyba vyhľadávania. Skúste to znova.",
        "found": "Nájdený pacient",
        "confirm": "Potvrďte",
        "ambiguous": "Viacero zhôd",
        "ambiguous-hint-firstname": "Na spresnenie vyhľadávania zadajte aj svoje krstné meno.",
        "ambiguous-hint-additional": "Skontrolujte svoje údaje alebo kontaktujte personál.",
        "not-found": "Pacient sa nenašiel",
        "not-found-hint": "S týmito údajmi sa nepodarilo nájsť žiadneho pacienta.",
        "not-found-action": "Skúste to znova"
      },
      "manual-identification": {
        "unverified": "Vaša totožnosť nebola potvrdená kartou zdravotného poistenia. Ambulancia pred spracovaním overí vaše údaje a žiadosť."
      },
      "medication-selection": {
        "title": "Vyžiadajte si recept",
        "subtitle": "Ordinácia posúdi vašu žiadosť. Po schválení bude eRx pripravený vo vašej aplikácii e-prescription.",
        "back": "Späť",
        "submit": "Pokračujte v kontrole",
        "reason-title": "Prečo potrebujete recept?",
        "reason-hint": "Pomáha ordinácii posúdiť vašu žiadosť.",
        "reason-validation": "Vyberte dôvod.",
        "reason-schmerzen": "Bolesť",
        "reason-entzuendung": "Zápal",
        "reason-nachsorge": "Po chirurgickom zákroku /",
        "reason-allergie": "Alergia / reakcia",
        "reason-chronisch": "Chronický stav",
        "reason-anderes": "Niečo iné",
        "medications-title": "Aké lieky?",
        "request-hint": "Popíšte, čo potrebujete, alebo pomenujte predchádzajúci recept, ktorý chcete obnoviť.",
        "request-placeholder": "napr. Ibuprofen 600 mg, rovnako ako naposledy",
        "request-validation": "Opíšte prosím, ktoré lieky potrebujete.",
        "history-title": "Predchádzajúce predpisy",
        "history-hint": "Pridajte záznam na predvyplnenie vašej požiadavky.",
        "history-loading": "Načítavam predchádzajúce recepty...",
        "history-error": "Predchádzajúce recepty sa nepodarilo načítať.",
        "history-add": "Pridať",
        "history-added": "Pridané",
        "history-date": "Posledný: {{date}}",
        "history-request-line": "Obnoviť: {{medicationName}}",
        "urgency-title": "Aké naliehavé je to?",
        "urgency-hint": "Pomáha ordinácii určiť prioritu.",
        "urgency-soon": "Naliehavé",
        "urgency-soon-meta": "Čo najskôr",
        "urgency-tomorrow": "Čoskoro",
        "urgency-tomorrow-meta": "V najbližších dňoch",
        "urgency-week": "Tento týždeň",
        "urgency-week-meta": "Žiadna časová tieseň",
        "lead": "Ambulancia vašu žiadosť posúdi. Po schválení nájdete svoj e-recept v aplikácii pre e-recepty alebo na preukaze poistenca.",
        "history-hint-v2": "Ťuknite na skorší recept a prevezmite ho.",
        "history-retry": "Načítať znova"
      },
      "request-review": {
        "title": "Revízny príkaz",
        "subtitle": "Skontrolujte si svoju žiadosť o predpis.",
        "request-label": "Požadovaný liek",
        "selected-medications": "Vybrané lieky",
        "free-text-medications": "Ďalšie lieky",
        "freetext-label": "Iné",
        "quarterly-warning": "Vaša karta poistenca nebola v tomto štvrťroku načítaná. Ordinácia vás môže kontaktovať.",
        "egk-warning": "Vaša karta poistenca nebola v tomto štvrťroku načítaná. Ordinácia vás môže kontaktovať.",
        "submit": "Odoslať",
        "submitting": "Odosielanie...",
        "submit-error": "Žiadosť sa nepodarilo odoslať. Skúste to znova.",
        "back": "Späť",
        "reason-label": "Dôvod",
        "urgency-label": "Naliehavosť",
        "completion-email-choice": "Chcem dostať e-mail, keď ambulancia spracuje moju žiadosť.",
        "completion-email-label": "E-mailová adresa",
        "completion-email-placeholder": "meno@priklad.sk",
        "completion-email-hint": "Len pre túto jednorazovú správu. Adresa sa neuloží do kmeňových údajov.",
        "completion-email-invalid": "Zadajte platnú e-mailovú adresu.",
        "egk-proof-required": "Žiadosti o recept sú dostupné iba po úspešnom načítaní karty poistenca. Obráťte sa prosím na personál.",
        "title-v2": "Skontrolovať žiadosť",
        "completion-email-hint-v2": "Adresa sa použije len na túto jednu správu."
      },
      "confirmation": {
        "title": "Žiadosť odoslaná",
        "subtitle": "Vaša žiadosť o predpis bola úspešne odoslaná.",
        "success-title": "Žiadosť odoslaná",
        "success-subtitle": "Vaša žiadosť o predpis bola úspešne odoslaná.",
        "estimated-time": "Váš recept bude pripravený približne za {{time}}.",
        "info": "Recept si môžete vyzdvihnúť v lekárni pomocou karty poistenca alebo aplikácie eRezept.",
        "auto-redirect": "Automatické presmerovanie za {{seconds}} sekúnd",
        "back-to-start": "Späť na začiatok",
        "handling-label": "Handled by the practice",
        "next-steps": "Ambulancia vašu žiadosť posúdi. Po schválení si môžete e-recept vyzdvihnúť v lekárni s preukazom poistenca alebo v aplikácii pre e-recepty."
      },
      "phase": {
        "identify": "Prihlásenie",
        "request": "Žiadosť",
        "review": "Kontrola"
      }
    },
    "check-in": {
      "flow-label": "Registrácia",
      "has-appointment": {
        "eyebrow": "Menovanie",
        "title": "Máte objednanie?",
        "subtitle": "Prosím vyberte možnosť",
        "yes-label": "Áno",
        "yes": "Áno, mám objednanie",
        "yes-description": "Chcem sa zaregistrovať na svoj termín.",
        "yes-hint": "Najrýchlejšia cesta",
        "unsure-label": "Možno",
        "unsure": "Nie som si istý",
        "unsure-description": "Skontrolujeme to za vás.",
        "unsure-hint": "Vyhľadáme vás",
        "no-label": "č",
        "no": "Nie, bez objednania",
        "no-description": "Nemám objednanie.",
        "no-hint": "Walk-in"
      },
      "card-check": {
        "eyebrow": "Karta poistenca",
        "title": "Prečítať zdravotnú kartu",
        "subtitle": "Prosím vložte svoju zdravotnú kartu do čítačky",
        "insert-title": "Vložte kartu zdravotného poistenia do čítačky.",
        "insert-detail": "Vaše údaje čítame automaticky — nemusíte robiť nič iné.",
        "other-ways": "Iné spôsoby",
        "no-card-hint": "Ak práve nemáte pri sebe svoju kartu.",
        "pkv-hint": "Použite QR code s aplikáciou poistenia.",
        "loading": "Načítavanie nastavení...",
        "no-terminal": "Nie je nakonfigurovaná žiadna čítačka kariet. Prosím kontaktujte personál.",
        "checking": "Kontrola kariet...",
        "insert-prompt": "Prosím vložte kartu...",
        "card-detected": "Karta detekovaná! Pripravená na čítanie.",
        "read-card": "Prečítať kartu",
        "simulate-insert": "Simulovať kartu",
        "reading": "Čítanie karty...",
        "error": "Nie je možné prečítať kartu. Prosím skúste to znova.",
        "read-error": "Chyba pri čítaní údajov z karty. Prosím skúste to znova.",
        "settings-error": "Nie je možné načítať nastavenia. Prosím skúste to znova.",
        "no-card-prompt": "Nemáte kartu pri sebe?",
        "no-card-action": "Manuálne vyhľadávanie",
        "connection-warning": "Problémy s pripojením čítačky kariet. Čakajte prosím...",
        "pkv-prompt": "Súkromné poistenie? Online Check-in",
        "pkv-instruction": "Naskenujte tento QR code pomocou aplikácie súkromného zdravotného poistenia a preneste svoje údaje digitálne.",
        "pkv-continue": "Pokračujte v manuálnej registrácii",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Skúste to znova alebo sa prihláste bez karty. Recepcia vám rada pomôže.",
        "title-pkv": "Prihlásenie cez aplikáciu",
        "title-reading": "Vaša karta sa načítava …",
        "title-unreadable": "Kartu sa nepodarilo načítať",
        "title-no-terminal": "Prihlásenie bez karty",
        "no-terminal-body": "Čítačka kariet teraz nie je k dispozícii. Prihláste sa bez karty alebo sa obráťte na recepciu.",
        "reading-detail": "Nechajte kartu v čítačke. Potrvá to len chvíľku.",
        "other-ways-title": "Ďalšie možnosti",
        "no-card-title": "Prihlásiť sa bez karty",
        "pkv-prompt-title": "Súkromne poistený?",
        "pkv-prompt-hint": "Prihlásenie cez aplikáciu vášho súkromného zdravotného poistenia",
        "pkv-close": "Predsa len s kartou",
        "pkv-instruction-app": "Otvorte aplikáciu svojho súkromného zdravotného poistenia a naskenujte tento kód. Vaše údaje potom prídu priamo k nám."
      },
      "patient-selection": {
        "title": "Vyberte pacienta",
        "subtitle": "Nájdených viac pacientov. Prosím vyberte seba.",
        "firstname-label": "Vaše krstné meno",
        "firstname-placeholder": "Zadajte krstné meno...",
        "confirm-button": "Potvrďte",
        "no-match": "Nenašiel sa žiadny zodpovedajúci pacient. Požiadajte o pomoc na recepciu.",
        "still-ambiguous": "Zostáva viacero zhôd. Požiadajte o pomoc na recepciu.",
        "select-error": "Nepodarilo sa identifikovať pacienta. Skúste to znova.",
        "staff-assist": "Choďte na recepciu",
        "title-v2": "Krátka otázka",
        "subtitle-v2": "Pre istotu zadajte svoje krstné meno.",
        "no-match-v2": "S týmto krstným menom sme vás nenašli. Skontrolujte pravopis alebo sa obráťte na recepciu.",
        "still-ambiguous-v2": "Zatiaľ sme vás nemohli jednoznačne nájsť. Obráťte sa na recepciu.",
        "select-error-v2": "To sa, žiaľ, nepodarilo. Skúste to znova."
      },
      "card-checkin": {
        "title": "Potvrdiť registráciu",
        "subtitle": "Vaše údaje boli úspešne prečítané.",
        "confirm": "Potvrdiť registráciu"
      },
      "register-from-card": {
        "title": "Nová registrácia",
        "subtitle": "Ešte nie ste v našom systéme. Chcete sa zaregistrovať?",
        "card-data": "Údaje o karte",
        "create": "Zaregistrovať sa",
        "create-error": "Registrácia zlyhala. Skúste to znova alebo požiadajte o pomoc personál.",
        "staff-assist": "Zavolajte personál",
        "no-card-data-title": "Žiadne údaje o karte",
        "no-card-data": "Nie je možné prečítať údaje z vašej karty.",
        "insurance-verified": "Overené poistenie: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Vaše údaje z karty",
        "subtitle-v2": "Skontrolujte svoje údaje. Ak niečo nesedí, ťuknite na „Zmeniť“.",
        "create-v2": "Potvrdiť údaje",
        "create-error-v2": "Prihlásenie sa, žiaľ, nepodarilo. Skúste to znova alebo sa obráťte na recepciu.",
        "insurer-missing-v2": "Na vašej karte chýba údaj o zdravotnej poisťovni. Obráťte sa na recepciu.",
        "edit": "Zmeniť",
        "name": "Meno",
        "insurer": "Zdravotná poisťovňa"
      },
      "patient-lookup": {
        "title": "Vyhľadať pacienta",
        "subtitle": "Prosím zadajte svoje meno alebo číslo poistenia.",
        "lastname": "Priezvisko",
        "lastname-placeholder": "Vaše priezvisko",
        "dob": "Dátum narodenia",
        "firstname": "Krstné meno",
        "firstname-placeholder": "Vaše krstné meno",
        "search": "Hľadať",
        "searching": "Vyhľadávanie...",
        "search-placeholder": "Meno alebo číslo poistenia...",
        "results-placeholder": "Výsledky vyhľadávania sa objavia tu",
        "found": "Pacient nájdený!",
        "confirm-identity": "Potvrďte, že ste zobrazený pacient.",
        "confirm-button": "To som ja",
        "ambiguous-firstname": "Našlo sa viacero pacientov. Zadajte svoje krstné meno.",
        "ambiguous-additional": "Našlo sa viacero pacientov. Kontaktujte prosím personál.",
        "disambiguation-hint": "Pomôže nám to jasne vás identifikovať.",
        "not-found": "Nebol nájdený žiadny pacient s týmito údajmi.",
        "error": "Chyba vyhľadávania: {{message}}",
        "staff-assist": "Zavolajte personál",
        "not-found-prompt": "Nenašlo sa?",
        "register-new": "Zaregistrovať nového",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Prihlásenie bez karty",
        "subtitle-firstname": "Zadajte aj svoje krstné meno.",
        "ambiguous-firstname-v2": "Toto priezvisko má viac osôb. Zadajte aj svoje krstné meno.",
        "search-again": "Hľadať znova",
        "found-v2": "Našli sme vás",
        "found-confirm": "Potvrďte tlačidlom „To som ja“.",
        "not-found-title": "Nenašli sme vás",
        "not-found-check": "Skontrolujte pravopis a dátum narodenia. Recepcia vám rada pomôže.",
        "not-found-reception": "Skontrolujte pravopis a dátum narodenia alebo sa obráťte na recepciu.",
        "ambiguous-additional-v2": "Nemohli sme vás jednoznačne nájsť. Obráťte sa na recepciu.",
        "error-v2": "Hľadanie sa teraz nepodarilo. Skúste to znova."
      },
      "checking-in": {
        "title": "Moment – kontrolujeme vás.",
        "subtitle": "Pridávame vás do poradia ošetrení a informujeme tím.",
        "step-insurance": "Poistenie skontrolované",
        "step-appointment": "Menovanie potvrdené",
        "step-waitlist": "Pridanie do zoznamu čakateľov",
        "error": "Prihlásenie zlyhalo. Skúste to znova.",
        "continue": "Napriek tomu pokračovať",
        "title-v2": "Chvíľku, prosím",
        "loading": "Prihlasujeme vás …",
        "subtitle-v2": "Zapisujeme vás do čakacieho zoznamu a dávame vedieť tímu.",
        "error-title": "To sa, žiaľ, nepodarilo",
        "error-v2": "Vaše prihlásenie sa nepodarilo dokončiť.",
        "error-body": "Skúste to znova. Ak to opäť nepôjde, pomôže vám recepcia."
      },
      "appointment-selection": {
        "title": "Zvoľte termín",
        "subtitle": "Dnes máte niekoľko stretnutí. Vyberte si jednu.",
        "checking-in": "Prihlasujem sa...",
        "time": "{{time}}",
        "error-v2": "Prihlásenie na tento termín sa nepodarilo. Skúste to znova alebo sa obráťte na recepciu."
      },
      "no-appointment": {
        "title": "Nenašiel sa žiadny termín",
        "subtitle": "Dnes sa nám nepodarilo nájsť schôdzku. Prosím, rezervujte si pravidelný termín.",
        "book-appointment": "Objednajte si termín",
        "book-appointment-description": "Zarezervujte si nový termín prostredníctvom bežného plánovača.",
        "staff-assist": "Zavolajte personál",
        "staff-assist-description": "Potrebujem pomoc.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Dnes sme pre vás nenašli žiadny termín.",
        "book-v2": "Dohodnúť nový termín",
        "book-v2-description": "Vyberte si teraz voľný termín.",
        "have-appointment": "Mám termín",
        "have-appointment-description": "Recepcia vám rada pomôže.",
        "unavailable-title": "Termíny si dohodnite na recepcii",
        "subtitle-unavailable": "Dnes sme pre vás nenašli žiadny termín. Obráťte sa na recepciu."
      },
      "staff-assist": {
        "title": "Personál bol upozornený",
        "subtitle": "Zamestnanec vám čoskoro pomôže.",
        "message": "Čakajte prosím tu. Zamestnanec bude s vami čoskoro.",
        "start-over": "Späť na začiatok",
        "auto-redirect": "Návrat na začiatok o {{seconds}} sekúnd..."
      },
      "eeb-prompt": {
        "title": "Overiť poistenie",
        "title-failed": "Overenie zlyhalo",
        "subtitle": "Ako chcete overiť svoje poistenie?",
        "subtitle-failed": "Naskenujte QR kód svojou poisťovacou aplikáciou pre žiadosť o overenie.",
        "verify-card": "Overiť elektronicky",
        "verify-card-description": "Odoslať žiadosť vašej poisťovni.",
        "select-insurer": "Vybrať poisťovňu",
        "select-insurer-description": "Manuálny výber vašej poisťovne.",
        "skip": "Preskočiť",
        "eyebrow-chip": "Alternatíva",
        "eyebrow": "Registrácia · doklad o poistení (eEB)",
        "recommended": "Odporúčané",
        "qr-title": "Skenujte pomocou aplikácie poistenia",
        "qr-description": "Otvorte aplikáciu zdravotného poistenia a naskenujte kód – eEB sa odošle priamo nám.",
        "qr-address-label": "Odoslať komu",
        "title-app": "Potvrdenie cez aplikáciu",
        "subtitle-app": "Vaša poisťovňa nám môže potvrdenie poslať aj priamo. Keď budete hotoví, ťuknite na „Ďalej“."
      },
      "quarterly-check": {
        "title": "Kontrola poistenia",
        "checking": "Kontrolujeme vaše aktuálne overenie poistenia...",
        "error": "Kontrola nemohla byť vykonaná.",
        "title-v2": "Vaše poistenie",
        "checking-v2": "Kontrolujeme vaše poistenie – chvíľku, prosím.",
        "error-body": "Vaše prihlásenie je hotové. Poistenie s vami vybaví recepcia."
      },
      "insurer-prefilled": {
        "title": "Vaše zdravotné poistenie",
        "subtitle": "Prosím potvrďte svoje poistenie pre toto štvrťročie.",
        "your-insurance": "Vaše poistenie",
        "last-read": "Naposledy skontrolované {{date}}",
        "quarterly-notice": "Pre účely fakturácie potrebujeme aktuálny doklad o poistení pre toto štvrťročie.",
        "confirm-button": "Áno, toto je moje poistenie",
        "change-button": "Mám iné poistenie",
        "contact-title": "Požiadajte o elektronický doklad o pokrytí",
        "contact-description": "Zavolajte do svojej poisťovne a požiadajte o elektronický doklad o krytí pre:",
        "contact-patient": "Pacient",
        "contact-kim-address": "KIM adresa ordinácie",
        "contact-phone": "Telefón",
        "question": "Je toto vaša zdravotná poisťovňa?",
        "quarterly-notice-v2": "Raz za štvrťrok potrebujeme potvrdenie od vašej poisťovne."
      },
      "insurer-search": {
        "title": "Vyberte zdravotné poistenie",
        "subtitle": "Prosím vyhľadajte a vyberte svoje povinné zdravotné poistenie.",
        "placeholder": "Vyhľadať poistenie...",
        "hint": "Zadajte aspoň 2 znaky pre vyhľadávanie.",
        "no-results": "Nenašlo sa žiadne poistenie.",
        "no-results-hint": "Skontrolujte pravopis alebo skúste iné vyhľadávanie.",
        "label": "Názov vašej zdravotnej poisťovne",
        "search-error-v2": "Hľadanie sa teraz nepodarilo. Skúste to znova.",
        "app-alternative": "Radšej cez aplikáciu svojej poisťovne?"
      },
      "insurer-contact": {
        "title": "Požiadajte o potvrdenie o poistení",
        "subtitle": "Vyberte si jednu z nasledujúcich možností.",
        "or": "alebo",
        "option-eeb-title": "Žiadosť elektronicky",
        "option-eeb-description": "Ak nastal zákonný výnimočný prípad, po vašom súhlase môžete odovzdať žiadosť tímu ambulancie.",
        "option-qr-title": "Skenovanie pomocou aplikácie",
        "option-qr-description": "Naskenujte QR code pomocou aplikácie poistenia.",
        "option-call-title": "Zavolajte si",
        "option-call-description": "Zavolajte svojej poisťovni a požiadajte o eEB pre túto ordináciu:",
        "phone": "Telefón",
        "phone-not-available": "Telefónne číslo na karte poistenca",
        "patient-name": "Pacient",
        "practice-kim": "KIM adresa ordinácie",
        "help-notice": "Ak máte nejaké problémy, navštívte prosím recepciu.",
        "submit-eeb-button": "Požiadať teraz",
        "contacted-button": "Volal som",
        "contacted-button-countdown": "Čas na váš hovor ({{seconds}}s)",
        "go-to-counter-button": "Prejsť na recepciu",
        "qr-continue-button": "Naskenoval som",
        "qr-continue-button-countdown": "Čas na skenovanie ({{seconds}}s)",
        "title-v2": "Potvrdenie od vašej zdravotnej poisťovne",
        "subtitle-v2": "Najjednoduchšie je to cez aplikáciu vašej poisťovne.",
        "subtitle-no-app": "Vyberte, ako nám má vaša poisťovňa poslať potvrdenie.",
        "option-eeb-description-v2": "Požiadame vašu poisťovňu za vás. Na to potrebujeme váš súhlas.",
        "call-instruction": "Zavolajte svojej poisťovni a požiadajte o zaslanie potvrdenia do našej ambulancie.",
        "call-instruction-practice": "Zavolajte svojej poisťovni a požiadajte o zaslanie potvrdenia do ambulancie {{practice}}.",
        "done-button": "Hotovo – ďalej",
        "done-button-countdown": "Hotovo – ďalej (ešte {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Súhlas",
        "subtitle": "Potrebujeme váš súhlas pre elektronické overenie poistenia.",
        "insurance": "Vaše poistenie",
        "consent-title": "Súhlas s elektronickým overením poistenia (eEB)",
        "consent-text": "Rozumiem, že moja zdravotná poisťovňa odošle moje poistné údaje (napr. meno, dátum narodenia, číslo poistenca) cez zabezpečenú komunikačnú službu KIM do ordinácie {{practiceName}} ako doklad o poistení. Súhlasím s týmto prenosom. Som si vedomý/á, že tento súhlas môžem kedykoľvek odvolať bez vplyvu na moju liečbu.",
        "withdrawal-notice": "Tento súhlas môžete kedykoľvek odvolať.",
        "agree-button": "Súhlasím",
        "decline-button": "Zrušiť",
        "treatment-notice": "Vaše liečenie nie je týmto súhlasom ovplyvnené.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Potvrdenie od vašej zdravotnej poisťovne",
        "summary": "Vaša poisťovňa nám pošle potvrdenie priamo. Na to potrebujeme váš súhlas.",
        "confirm-first": "Najprv potvrďte vyhlásenie."
      },
      "qr-code": {
        "title": "Naskenovať poisťovacou aplikáciou",
        "instruction-1": "Otvorte svoju poisťovaciu aplikáciu a naskenujte tento QR kód.",
        "instruction-2": "Ordinácia potom automaticky dostane overenie vášho poistenia.",
        "practice": "Ordinácia: {{name}}",
        "alternative-hint": "Alternatíva: Použite svoju poisťovaciu aplikáciu",
        "instruction-app": "Otvorte aplikáciu svojej zdravotnej poisťovne a naskenujte tento kód. Potvrdenie potom príde priamo k nám.",
        "staff-line": "Pre tím ambulancie: {{address}}",
        "staff-line-practice": "Pre tím ambulancie: {{name}} · {{address}}",
        "alternative-app": "Potvrdenie si môžete vyžiadať aj cez aplikáciu svojej poisťovne: otvorte aplikáciu a naskenujte tento kód."
      },
      "register-basics": {
        "title": "Osobné údaje",
        "subtitle": "Prosím zadajte svoje údaje.",
        "family-name": "Priezvisko",
        "given-name": "Meno",
        "dob": "Dátum narodenia",
        "gender": "Pohlavie",
        "insurance-type": "Typ poistenia",
        "insurer-name": "Názov vašej poistky",
        "insurer-name-placeholder": "napr. Debeka, DKV, Allianz...",
        "gender-required": "Vyberte jednu možnosť."
      },
      "register-insurer": {
        "title": "Zdravotné poistenie",
        "subtitle": "Prosím vyberte svoje zdravotné poistenie.",
        "search-placeholder": "Vyhľadať poistenie..."
      },
      "register-details": {
        "title": "Súhrn",
        "subtitle": "Prosím skontrolujte svoje údaje.",
        "create": "Dokončiť registráciu",
        "missing-data": "Vyplňte prosím všetky povinné polia.",
        "create-error": "Registrácia zlyhala. Skúste to znova.",
        "policy-number": "Číslo poistky (voliteľné)",
        "policy-number-placeholder": "Číslo vašej poistky",
        "create-v2": "Dokončiť prihlásenie",
        "policy-number-hint": "Číslo nájdete na karte svojho poistenia."
      },
      "diff-review": {
        "eyebrow-chip": "Preskúmanie",
        "eyebrow": "Check-in · údaje o karte",
        "title": "Porovnanie údajov",
        "subtitle": "Boli nájdené rozdiely medzi údajmi z vašej karty a našimi záznamami.",
        "col-current": "Aktuálny záznam",
        "col-new": "Nové z karty",
        "new-badge": "nový",
        "field-fallback": "Pole",
        "note": "Aktualizované údaje nám pomáhajú správne účtovať a kontaktovať vás v prípade núdze.",
        "comparison-placeholder": "Porovnanie bude zobrazené tu",
        "confirm": "Potvrdiť zmeny",
        "apply-error": "Údaje nebolo možné použiť. Skúste to znova.",
        "retry": "Skúste to znova",
        "skip": "Napriek tomu pokračovať",
        "no-changes": "Nenašli sa žiadne zmeny",
        "title-v2": "Vaše údaje sa zmenili",
        "subtitle-v2": "Na vašej karte sú novšie údaje. Máme ich prevziať?",
        "confirm-v2": "Prevziať a prihlásiť",
        "keep": "Prihlásiť bez zmeny",
        "col-current-v2": "Doteraz",
        "col-new-v2": "Nové z karty",
        "value-yes": "Áno",
        "value-no": "Nie"
      },
      "insurance-selection": {
        "title": "Typ poistenia",
        "subtitle": "Prosím vyberte svoj typ poistenia.",
        "gkv": "Zákonné poistený",
        "gkv-description": "Člen povinného zdravotného poistenia.",
        "pkv": "Súkromné alebo samoplatba",
        "pkv-description": "Súkromne poistený alebo samoplatba.",
        "pkv-description-v2": "Súkromné zdravotné poistenie, alebo platíte sami."
      },
      "eeb-request": {
        "title": "Žiadosť zaznamenaná",
        "subtitle": "Môžete dokončiť registráciu. Odpoveď od {{insurer}} príde do ambulancie neskôr.",
        "verifying": "Vaša žiadosť bola prijatá na okamžité spracovanie.",
        "success": "Vaša žiadosť bola bezpečne odovzdaná tímu ambulancie.",
        "error": "Potvrdenie žiadosti nie je k dispozícii.",
        "try-alternative": "Alternatívna metóda",
        "kim-load-error": "KIM adresu ordinácie sa nepodarilo načítať.",
        "kim-label": "Ordinácia · KIM",
        "non-blocking-note": "Toto ešte nepotvrdzuje doručenie vašej zdravotnej poisťovni ani váš status poistenia.",
        "auto-continue": "O {{seconds}} sekúnd sa automaticky pokračuje.",
        "unavailable-title": "To sa, žiaľ, nepodarilo",
        "unavailable-v2": "Vašu žiadosť v zdravotnej poisťovni sa nepodarilo zaznamenať.",
        "unavailable-body": "Potvrdenie si môžete nechať poslať cez aplikáciu poisťovne alebo to vybaviť na recepcii.",
        "use-app": "Cez aplikáciu",
        "at-reception": "Vybaviť na recepcii"
      },
      "self-pay": {
        "title": "Samoplatba",
        "subtitle": "Budete ošetrení ako pacient so samoplatbou.",
        "info": "Prosím vezmite na vedomie, že ponesete zodpovednosť za náklady liečenia.",
        "confirm": "Rozumiem",
        "title-v2": "Platíte sami",
        "subtitle-v2": "Ošetrenie si platíte sami.",
        "insured-after-all": "Predsa som poistený"
      },
      "done": {
        "title": "Hotovo!",
        "subtitle": "Vaša registrácia je dokončená.",
        "finish": "Dokončiť",
        "done-label": "Hotovo",
        "error-label": "Upozornenie",
        "eyebrow": "Prihlásenie · dokončené",
        "queue-label": "Čakáreň",
        "queue-title": "Posaďte sa prosím",
        "queue-meta": "Zavoláme vám osobne.",
        "success-title": "Registrácia úspešná!",
        "success-subtitle": "Prosím posaďte sa v čakárni. Budete zavolaní.",
        "auto-redirect": "Čoskoro budete presmerovaní na úvodnú stránku...",
        "auto-redirect-countdown": "Návrat na začiatok o {{seconds}} sekúnd...",
        "card-expired-title": "Karta vypršala",
        "card-expired-subtitle": "Vaša zdravotná karta vypršala.",
        "card-expired-info": "Prosím kontaktujte personál pre pomoc.",
        "back-to-start": "Späť na začiatok",
        "anamnesis-title": "Vyplňte formulár anamnézy",
        "anamnesis-description": "Naskenujte QR code a pohodlne vyplňte formulár anamnézy na svojom smartfóne.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Ste prihlásený",
        "card-expired-info-v2": "Obráťte sa na recepciu."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Skontrolujte svoje údaje",
          "balance-prefix": "Pri uložení:",
          "balance-direct-v2": "Uložené hneď: {{count}}",
          "balance-reception-v2": "Skontroluje recepcia: {{count}}",
          "chip-reception-v2": "Zmeny kontroluje naša recepcia",
          "chip-changed": "Zmenené: {{count}}",
          "remove": "Odstrániť",
          "example-email": "napr. meno@priklad.sk",
          "example-phone": "napr. 0901 234 567",
          "intro-v2": "Vaše prihlásenie je hotové. Sú tieto údaje stále správne? Kontrola je dobrovoľná.",
          "auto-hide": "Zobrazené hodnoty sa po chvíli opäť skryjú."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Tento údaj sme odovzdali recepcii.",
          "banner-done-v2": "Ďakujeme! Vaše údaje sme dostali.",
          "footer-v2": "Všetky ostatné údaje zostávajú bez zmeny."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Z dôvodu ochrany údajov sme zobrazenie zavreli. Vaše prihlásenie je napriek tomu hotové. Zmeny môžete kedykoľvek oznámiť na recepcii."
        }
      },
      "progress": {
        "identify": "Prihlásenie",
        "insurance": "Poistenie",
        "done": "Hotovo"
      },
      "dob-format-hint": "Napríklad 01.10.1980",
      "dob-required": "Zadajte svoj dátum narodenia.",
      "insurance-label": {
        "GKV": "Zákonné poistenie",
        "PKV": "Súkromné poistenie",
        "SELFPAY": "Samoplatca"
      }
    },
    "emergency": {
      "title": "Akútna pohotovosť!",
      "label": "Pohotovosť",
      "subtitle": "Tento alarm je počuteľný iba miestne a neprivolal pomoc. Pri akútnom alebo potenciálne život ohrozujúcom stave volajte 112.",
      "call-emergency": "Zavolajte na pohotovostné služby (112)",
      "stop-sound": "Zastaviť zvuk",
      "play-sound": "Prehrať zvuk",
      "back-to-start": "Späť na začiatok",
      "headline": "Okamžite sa obráťte na personál na recepcii. Pri ohrození života volajte 112."
    },
    "help-reception": "Pomoc na recepcii",
    "help-reception-toast": "Kontaktujte recepciu. Radi pomôžeme.",
    "language-entry": {
      "title": "Vyberte jazyk"
    },
    "loading": "Načítava sa…",
    "step-progress-label": "Priebeh",
    "step-progress-phase": "Oddiel {{current}} z {{total}}: {{phase}}",
    "step-progress-substep": "Časť {{current}} z {{total}}",
    "step-progress-complete": "Dokončené",
    "identification": {
      "title": "Kto ste?",
      "lead": "Najrýchlejšie to ide s preukazom poistenca. Môžete hľadať aj podľa mena.",
      "lead-card-only": "Vložte, prosím, preukaz poistenca do čítačky kariet.",
      "mode-label": "Ako sa chcete prihlásiť?",
      "mode-card": "Kartou",
      "mode-search": "Hľadať podľa mena",
      "mode-create": "Nový pacient",
      "card": {
        "loading": "Pripravuje sa čítačka kariet …",
        "checking": "Kontroluje sa čítačka kariet …",
        "insert-title": "Vložte, prosím, preukaz poistenca do čítačky kariet.",
        "insert-detail": "Vaše údaje načítame automaticky.",
        "detected": "Karta rozpoznaná",
        "read": "Načítať kartu",
        "reading": "Karta sa načítava …",
        "reading-hint": "Nechajte, prosím, kartu vloženú.",
        "no-terminal-title": "Čítačka kariet nie je dostupná",
        "help-with-search": "Vyhľadajte sa, prosím, podľa mena alebo sa opýtajte na recepcii.",
        "help-reception": "Opýtajte sa, prosím, na recepcii – radi pomôžeme.",
        "unreadable-title": "Karta rozpoznaná, ale nečitateľná",
        "error-title": "Kartu sa nepodarilo načítať",
        "not-unique": "Nepodarilo sa vás jednoznačne priradiť ku karte. Vyhľadajte sa, prosím, podľa mena alebo sa opýtajte na recepcii.",
        "no-match": "K tejto karte sme nenašli žiadne údaje. Vyhľadajte sa, prosím, podľa mena alebo sa opýtajte na recepcii.",
        "without-card": "Pokračovať bez karty"
      },
      "lookup": {
        "lead": "Zadajte, prosím, svoje priezvisko a dátum narodenia.",
        "first-name": "Meno",
        "last-name": "Priezvisko",
        "dob": "Dátum narodenia",
        "dob-hint": "Formát: DD.MM.RRRR",
        "search": "Hľadať",
        "confirm": "Áno, to som ja",
        "found-title": "Našli sme vás",
        "found-body": "Potvrďte, prosím, že ide o vás.",
        "first-name-needed-title": "Doplňte, prosím, svoje meno",
        "first-name-needed-body": "Aby sme vás jednoznačne našli. Potom ťuknite na „Hľadať“.",
        "ambiguous-title": "Nepodarilo sa vás jednoznačne nájsť",
        "ambiguous-body": "Opýtajte sa, prosím, na recepcii – radi pomôžeme.",
        "not-found-title": "Nenašli sa žiadne zodpovedajúce údaje",
        "not-found-body": "Skontrolujte, prosím, zadané údaje.",
        "error-title": "Hľadanie teraz nie je možné",
        "error-body": "Skúste to, prosím, znova alebo sa opýtajte na recepcii."
      },
      "create": {
        "insurance-question": "Ako ste poistený/á?",
        "insurance-required": "Vyberte, prosím, ako ste poistený/á.",
        "error-title": "Vaše údaje sa nepodarilo uložiť",
        "error-body": "Skúste to, prosím, znova alebo sa opýtajte na recepcii."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Najprv odomknite",
      "subtitle": "FrontDesk+ musí byť aktivovaný vo vašom cvičnom softvéri.",
      "step1": "Objednajte si v SolStore (alebo za vás objedná váš partner Doc-Cirrus).",
      "step2": "Po aktivácii aktivujte v inSuite pod „inSuite Sols“ (práva správcu).",
      "step3": "Otvorte správu Bridge → „Pridať zariadenie“.",
      "cta": "Všetko hotovo - pokračujte"
    },
    "welcome": {
      "title": "Pridajte toto zariadenie do praxe",
      "scan": "Odfoťte kód",
      "prepare-link": "Žiadny kód v inSuite?",
      "language": "Jazyk"
    },
    "scan": {
      "requesting": "Vyžaduje sa prístup ku kamere…",
      "scanning": "Namierte fotoaparát na kód",
      "paste": "Namiesto toho prilepte",
      "manual-title": "Pripojte manuálne",
      "manual-description": "Ak QR kód nie je dostupný, vezmite si údaje o pripojení z administrácie Bridge.",
      "address-label": "Adresa Bridge",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Vložte SOLTOKEN",
      "manual-submit": "Prevezmite spojenie",
      "error-title": "Kód nebol rozpoznaný",
      "camera-denied-title": "Prístup k fotoaparátu bol odmietnutý",
      "camera-denied-hint": "Povoľte prístup k fotoaparátu v nastaveniach a skúste to znova.",
      "retry": "Skúste to znova"
    },
    "preflight": {
      "title": "Bude zriadené",
      "all-green": "Všetky testy prešli",
      "practice": "Prax",
      "device-name": "Názov zariadenia",
      "device-name-placeholder": "napr. B. Recepcia 1",
      "card-reader": "Čítačka kariet",
      "pin": "Nové tajné číslo",
      "pin-placeholder": "Štvormiestny PIN",
      "finish": "Dokončiť",
      "recheck": "Skontrolujte znova",
      "diagnosis": "Identifikátor diagnózy",
      "checklist-error": "Bridge odmietol pripojenie alebo nie je dostupný. Skontrolujte SOLTOKEN a adresu Bridge.",
      "checklist-retry": "Skontrolovať znova",
      "edit-token": "Zmeniť SOLTOKEN",
      "rescan": "Naskenovať kód znova"
    },
    "persisting": "Ukladanie nastavení …",
    "success": {
      "title": "Zariadenie bolo pridané",
      "detail": "Zariadenie sa práve objavilo na cvičnom PC.",
      "starting": "Spúšťa sa pacientsky režim…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Pripojenie k cvičnému softvéru",
        "fix": "Bridge Skontrolujte pripojenie a adresu servera."
      },
      "missing_insuite_url": {
        "label": "Adresa inSuite",
        "fix": "Naskenujte ešte raz QR kód – adresa chýba."
      },
      "missing_server_token": {
        "label": "Token servera",
        "fix": "Naskenujte znova QR kód – chýba token."
      },
      "missing_gateway_session": {
        "label": "Relácia Gateway",
        "fix": "Prihláste sa znova – relácia chýba."
      },
      "missing_gateway_enrollment": {
        "label": "Registrácia zariadenia",
        "fix": "Zaregistrujte zariadenie na Gateway."
      },
      "gateway_not_ready": {
        "label": "Pripravenosť Gateway",
        "fix": "Počkajte, kým Gateway dokončí nastavenie."
      },
      "token_verification_failed": {
        "label": "Tokenová kontrola",
        "fix": "Skontrolujte token servera alebo pripojenie Bridge."
      },
      "session_expired": {
        "label": "stretnutie",
        "fix": "Relácia vypršala - prihláste sa znova."
      },
      "device_revoked": {
        "label": "Stav zariadenia",
        "fix": "Toto zariadenie bolo zablokované. Kontaktujte prax."
      },
      "missing_practice_name": {
        "label": "Názov praxe",
        "fix": "Názov lekárskej praxe sa nepodarilo načítať (inSuite)."
      },
      "missing_device_name": {
        "label": "Názov zariadenia",
        "fix": "Zadajte názov zariadenia."
      },
      "telematik_unavailable": {
        "label": "Telematická infraštruktúra",
        "fix": "Voliteľné – kontrola karty je možná hneď, ako bude TI k dispozícii."
      },
      "selected_card_reader_unavailable": {
        "label": "Čítačka kariet",
        "fix": "Voliteľné — vyberte alebo pripojte čítačku kariet."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Voliteľné — vložte preukaz lekárskej praxe (SMC-B)."
      }
    },
    "token": {
      "title": "Zadajte SOLTOKEN",
      "description": "Z bezpečnostných dôvodov QR kód neobsahuje SOLTOKEN. Skopírujte ho v inSuite v časti „Sol-Aktivierung“ (FrontDesk+) a vložte ho sem.",
      "submit": "Pokračovať",
      "rescan": "Naskenovať kód znova"
    }
  }
}
